// TODO pull in non minified version
module.exports = require('exports-loader?LZString!ub/thirdparty/lz-string-1.3.3-min.js');



// WEBPACK FOOTER //
// ./src/require_wrappers/lz-string.js